(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-book-product"]) return;
  try {
    
function setupSelifuBook(root) {
  if(root.dataset.ready) return;
  const figures=[...root.querySelectorAll('[data-book-slide]')];
  const thumbs=[...root.querySelectorAll('[data-book-thumb]')];
  const dialog=root.querySelector('dialog');
  let current=0;
  function select(index) {
    current=(index+figures.length)%figures.length;
    figures.forEach((figure,i)=>{figure.hidden=i!==current;});
    thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===current)));
    const row=root.querySelector('.sc-book__thumbs');
    const thumb=thumbs[current];
    if(thumb){const left=thumb.offsetLeft-row.offsetLeft;if(left<row.scrollLeft)row.scrollLeft=left;else if(left+thumb.offsetWidth>row.scrollLeft+row.clientWidth)row.scrollLeft=left+thumb.offsetWidth-row.clientWidth;}
  }
  thumbs.forEach((thumb,i)=>{
    thumb.addEventListener('click',()=>select(i));
    thumb.addEventListener('keydown',event=>{
      if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
      event.preventDefault();
      const next=event.key==='Home'?0:event.key==='End'?thumbs.length-1:current+(event.key==='ArrowRight'?1:-1);
      select(next);thumbs[current].focus();
    });
  });
  root.querySelectorAll('[data-book-zoom-image]').forEach(button=>button.addEventListener('click',()=>{
    const img=figures[current].querySelector('img');const zoomImg=dialog.querySelector('img');
    zoomImg.src=figures[current].dataset.full||img.currentSrc||img.src;zoomImg.alt=img.alt;
    dialog.querySelector('[data-book-zoom-warning]').hidden=!figures[current].querySelector('[data-book-colour-example]');
    dialog.showModal();
  }));
  dialog.querySelector('[data-book-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  const purchase=root.querySelector('[data-book-purchase]');
  const panels=[...purchase.querySelectorAll('[data-edition-panel]')];
  const editionButtons=[...purchase.querySelectorAll('[data-book-edition]')];
  editionButtons.forEach(button=>button.addEventListener('click',()=>{
    purchase.querySelector('[data-edition-title]').textContent=button.dataset.bookEdition==='digital'?purchase.dataset.digitalTitle:purchase.dataset.physicalTitle;
    panels.forEach(panel=>panel.hidden=panel.dataset.editionPanel!==button.dataset.bookEdition);
    purchase.querySelectorAll('[data-edition-price]').forEach(price=>price.hidden=price.dataset.editionPrice!==button.dataset.bookEdition);
    editionButtons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    root.querySelectorAll('[data-edition-description]').forEach(description=>{description.hidden=description.dataset.editionDescription!==button.dataset.bookEdition;});
  }));
  const country=purchase.querySelector('[data-amazon-country]');
  const amazon=purchase.querySelector('[data-book-amazon]');
  if(country&&amazon){
    const domains={US:'amazon.com',ES:'amazon.es',GB:'amazon.co.uk',DE:'amazon.de',FR:'amazon.fr',IT:'amazon.it',CA:'amazon.ca',AU:'amazon.com.au',JP:'amazon.co.jp',NL:'amazon.nl',PL:'amazon.pl',SE:'amazon.se',IE:'amazon.ie',BE:'amazon.com.be'};
    const neighbours={PT:'ES',AT:'DE',NZ:'AU'};
    let manuallySelected=false;
    function setCountry(code){const mapped=neighbours[code]||code;if(!domains[mapped])return;country.value=mapped;amazon.href='https://www.'+domains[mapped]+'/dp/'+amazon.dataset.asin;}
    let saved;try{saved=localStorage.getItem('selifu-amazon-country');}catch{}
    setCountry(saved||purchase.dataset.country);
    country.addEventListener('change',()=>{manuallySelected=true;setCountry(country.value);try{localStorage.setItem('selifu-amazon-country',country.value);}catch{}});
    if(!saved&&window.Shopify?.routes?.root){
      fetch(window.Shopify.routes.root+'browsing_context_suggestions.json?country[enabled]=true').then(response=>response.ok?response.json():null).then(data=>{const code=data?.detected_values?.country?.handle||data?.suggestions?.[0]?.parts?.country?.handle;if(code&&!manuallySelected)setCountry(code);}).catch(()=>{});
    }
  }
  const buy=purchase.querySelector('[data-book-buy]');
  if(buy){
    buy.form.addEventListener('submit',async event=>{
      if(event.submitter!==buy)return;
      event.preventDefault();
      if(buy.dataset.busy)return;
      buy.dataset.busy='true';
      const error=purchase.querySelector('[data-book-buy-error]');error.hidden=true;
      const controls=[...buy.form.querySelectorAll('button')];controls.forEach(control=>control.disabled=true);
      try{
        const route=window.Shopify?.routes?.root||'/';
        const response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:buy.form.elements.id.value,quantity:1}]})});
        const result=await response.json();
        if(!response.ok)throw Error(result.description||result.message||root.dataset.buyError);
        window.location.assign(route+'checkout');
      }catch(reason){error.textContent=reason.message||root.dataset.buyError;error.hidden=false;controls.forEach(control=>control.disabled=false);}
      finally{delete buy.dataset.busy;}
    });
  }
  root.dataset.ready='true';
}
document.querySelectorAll('[data-selifubook]').forEach(setupSelifuBook);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-selifubook]').forEach(setupSelifuBook));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sc-hero]').forEach((hero) => {
    const heroCta = hero.querySelector('[data-sc-hero-cta]');
    const stickyBuy = hero.querySelector('[data-sc-sticky-buy]');
    if (!heroCta || !stickyBuy || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 240);
    }, { threshold: 0 });
    observer.observe(heroCta);
  });

  } catch(e) { console.error(e); }
})();
})();
